<style lang="less" scoped>
    @import "./admin.less";
</style>

<template>
	<div class="layout admin" :class="{'layout-hide-text': spanLeft < 5}">
        <Row type="flex">
            <Col :span="spanLeft" class="layout-menu-left">
                <Menu :active-name="active" theme="light" width="auto" @on-select="handleMenu">
                    <div class="layout-logo-left">
                    	<img src="../assets/logo.png" alt="">
                    </div>
                    <MenuItem name="list">
                        <Icon type="home" :size="14"></Icon>
                        <span class="layout-text">常见问题</span>
                    </MenuItem>
                    <MenuItem name="feed">
                        <Icon type="arrow-swap" :size="14"></Icon>
                        <span class="layout-text">用户提问</span>
                    </MenuItem>
                    <MenuItem name="report">
                        <Icon type="arrow-swap" :size="14"></Icon>
                        <span class="layout-text">统计</span>
                    </MenuItem>
                    <!-- <MenuItem name="2">
                        <Icon type="ios-keypad" :size="14"></Icon>
                        <span class="layout-text">产品类型</span>
                    </MenuItem> -->
                </Menu>
            </Col>
            <Col :span="spanRight" class="layout-menu-right">
                <div class="layout-header">
                    <Button type="text" @click="toggleClick">
                        <Icon type="navicon" size="32"></Icon>
                    </Button>
                </div>
                <div class="layout-content">
    				<router-view></router-view>
                </div>
                <div class="layout-copy">
                    2018 &copy; Teyes
                </div>
            </Col>
        </Row>
    </div>
</template>
<script>
	export default{
		data () {
            return {
                spanLeft: 5,
                spanRight: 19,
                type:'t8s',
                active:'list'
            }
        },
        computed: {
            iconSize () {
                return this.spanLeft === 5 ? 14 : 24;
            }

        },
        created(){
            console.log(this.$route.path)
            if(this.$route.path=='/admin'){
                var type = this.$route.query.type?this.$route.query.type:'cc'
                this.$router.push({
                    path:'/admin/list?type='+type
                })
            }
            this.active = this.$route.path.replace('/admin/','')
            this.type=window.location.hash.split('type=')[1]
        },
        methods: {
            toggleClick () {
                if (this.spanLeft === 5) {
                    this.spanLeft = 2;
                    this.spanRight = 22;
                } else {
                    this.spanLeft = 5;
                    this.spanRight = 19;
                }
            },
            handleMenu(name){
                console.log(name)
                this.$router.push({
                    path:`/admin/${name}`,
                    query: {type:this.type}
                });
                
            }
        }
	}
</script>


// WEBPACK FOOTER //
// src/components/Admin.vue